import { Injectable } from '@angular/core';
import { PermissionsService } from './permissions.service';

/**
 * Simplified helpers for templates that need to check a handful of common permissions.
 */
@Injectable({
  providedIn: 'root'
})
export class PermissionsFacade {
  constructor(private permissions: PermissionsService) {}

  /** Indicates whether the user may manage the org billing plan. */
  canBillingManagePlan(): boolean {
    return this.permissions.can('Org.Billing.ManagePlan');
  }

  /** Indicates whether the user has the `Project.Edit` permission for the provided project. */
  canProjectEdit(projectId: string): boolean {
    return this.permissions.can('Project.Edit', projectId);
  }
}
